export default function () {
  const shareBtn = document.querySelector('[data-element-behavior=share]');
  const fallbackModal = document.querySelector('[data-element-dom=share-modal]');

  if (shareBtn && fallbackModal) {
    const closeShareModalBtn = fallbackModal.querySelector('[data-element-behavior=close-share-modal]');
    const copyLinkBtn = fallbackModal.querySelector('[data-element-behavior=copy-link]');

    const closeShareModal = () => {
      fallbackModal.style.display = 'none';
      fallbackModal.classList.remove('share__modal--is-open');
    }

    const openShareModal = () => {
      fallbackModal.style.display = 'block';
      fallbackModal.classList.add('share__modal--is-open');
    }

    shareBtn.addEventListener('click', event => {
      if (navigator.share) {
        const title = shareBtn.getAttribute('data-element-share-title');
        const url = shareBtn.getAttribute('data-element-share-url');
        navigator.share({
          title: title,
          url: url,
        }).then(() => {
          console.log('Thanks for sharing');
        }).catch(console.error);
      } else {
        console.log('fallback');
        openShareModal();
      }
    });

    closeShareModalBtn.addEventListener('click', event => {
      closeShareModal();
    });

    copyLinkBtn.addEventListener('click', event => {
      const content = fallbackModal.querySelector('.link__url');
      let timeoutHandler = null;
      let selection = window.getSelection();
      selection.removeAllRanges();
      let range = document.createRange();
      range.selectNodeContents(content);
      selection.addRange(range);
      document.execCommand('copy');
      selection.removeAllRanges();
      const bubble = fallbackModal.querySelector('.bubble');
      bubble.style.display = 'block';
      timeoutHandler = window.setTimeout( () => {
        bubble.style.display = 'none';
      }, 3000 );
    });
  }
}
